// TODO: Move these into a Survey model
export const LanguageOptions = {
  arabic: {
    name: 'Arabic',
    localised: 'العربية',
    extended: 'Arabic (العربية)',
    code: 'AR'
  },
  english: {
    name: 'English',
    localised: 'English',
    extended: 'English (English)',
    code: 'EN'
  },
  french: {
    name: 'French',
    localised: 'français',
    extended: 'French (français)',
    code: 'FR'
  },
  german: {
    name: 'German',
    localised: 'Deutsch',
    extended: 'German (Deutsch)',
    code: 'DE'
  },
  italian: {
    name: 'Italian',
    localised: 'italiano',
    extended: 'Italian (italiano)',
    code: 'IT'
  },
  chinese: {
    name: 'Chinese',
    localised: 'chinese',
    extended: 'Chinese (Traditional Chinese)',
    code: 'ZH'
  },
  japanese: {
    name: 'Japanese',
    localised: '日本語',
    extended: 'Japanese (japanese)',
    code: 'JA'
  },
  slovene: {
    name: 'Slovene',
    localised: 'slovene',
    extended: 'Slovene (slovene)',
    code: 'SL'
  },
  romansh: {
    name: 'Romansh',
    localised: 'romansh',
    extended: 'Romansh (romansh)',
    code: 'RM'
  },
  polish: {
    name: 'Polish',
    localised: 'polish',
    extended: 'Polish (polish)',
    code: 'PL'
  },
  chineseSimplified: {
    name: 'Chinese Simplified',
    localised: '简体中文',
    extended: 'Chinese (Simplified Chinese)',
    code: 'zh-Hans',
    // Use superscript for the little s
    displayCode: 'ZHˢ'
  },
  hindi: {
    name: 'Hindi',
    localised: 'हिन्दी',
    extended: 'Hindi (हिन्दी)',
    code: 'HI'
  },
  magahi: {
    name: 'Magahi',
    localised: 'मगही',
    extended: 'Magahi (मगही)',
    code: 'MAG'
  }
};

export const getLanguage = code => {
  return Object.values(LanguageOptions).find(
    language => language.code === code
  );
};
